var map = {
	"./template.betprofessor": 1152,
	"./template.betprofessor.tsx": 1152,
	"./template.betroyale": 1153,
	"./template.betroyale.tsx": 1153,
	"./template.default": 663,
	"./template.default.tsx": 663,
	"./template.fiestabet": 1154,
	"./template.fiestabet.tsx": 1154,
	"./template.questbet": 1155,
	"./template.questbet.tsx": 1155,
	"./template.ts": 975,
	"./template.vikingbet": 1156,
	"./template.vikingbet.tsx": 1156,
	"./template.volcanobet": 1157,
	"./template.volcanobet.tsx": 1157,
	"./template.wellbet": 1158,
	"./template.wellbet.tsx": 1158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2436;